import React, { createContext, PropsWithChildren, useContext } from "react";

interface ScreenDesignContextValue {
  forceMobile?: boolean;
}

const ScreenDesignContext = createContext<ScreenDesignContextValue>({});

export const ScreenDesignProvider = ({
  children,
  forceMobile = false,
}: PropsWithChildren<ScreenDesignContextValue>) => {
  return (
    <ScreenDesignContext.Provider value={{ forceMobile }}>
      {children}
    </ScreenDesignContext.Provider>
  );
};

export const useScreenDesignContext = () => useContext(ScreenDesignContext);
